.detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
}

.headline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.title {
  margin: 0;
  font-size: 1.125rem;
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.25rem 1rem;
  margin: 0;
}

.facts dt {
  color: var(--text-muted);
}

.facts dd {
  margin: 0;
}

.pieces {
  margin: 0;
  padding-left: 1.25rem;
}

.diagram {
  min-height: 16rem;
  height: 24rem;
  max-height: 60vh;
}

.downloads {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
